// The top of every page: a 24px bold title, one grey line of help under it,
// the page's actions on the right, and a small violet breadcrumb above when
// the page lives inside a module.
export function PageHeader({ title, subtitle, actions, breadcrumb }) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        {breadcrumb && <p className="mb-1.5"><span data-tc className="inline-flex items-center rounded-full bg-primary/10 px-2.5 py-0.5 text-[11px] font-semibold text-primary">{breadcrumb}</span></p>}
        <h1 className="font-display text-[20px] font-bold leading-7 tracking-[-0.02em] text-foreground">{title}</h1>
        {subtitle && <p className="mt-1 max-w-3xl text-sm leading-5 text-muted-foreground">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
